import * as React from "react";

function hostnameWithoutSubdomain() {
  return window.location.host.split(".").slice(-2).join(".");
}

interface GroupSummaryProps {
  group: GroupSnakeModel
  shouldShowExpiration: boolean
}

export default function GroupSummary(props: GroupSummaryProps) {
  const {
    group,
    shouldShowExpiration,
  } = props;

  let expirationView;
  if (group.expiration_date && shouldShowExpiration) {
    const date = new Date(group.expiration_date);
    const inThePast = date < new Date();
    const formattedDate = date.toLocaleString("en-US", {
      year: "numeric",
      month: "long",
      day: "numeric",
      hour: "numeric",
      minute: "2-digit",
      hour12: true,
    });

    if (inThePast) {
      expirationView = <span style={{color: "red"}}>Expired At: {formattedDate}</span>;
    } else {
      expirationView = <span style={{color: "black"}}>Expires At: {formattedDate}</span>;
    }
  }

  return (
    <div className="gen-select-item">
      <h1 className="name"><a href={`//${group.subdomain}.${hostnameWithoutSubdomain()}`}>{group.name}</a></h1>
      {expirationView}
      <p className="description">{group.description}</p>
    </div>
  );
}
